export default "__VITE_ASSET__B0ew7yA4__"